import { useContext } from 'react';
import { FormikStepperContext } from '../../provider/contexts/FormikStepperContext';

export const useFormikStepper = () => {
    const context = useContext(FormikStepperContext);
    if (!context) {
        throw new Error('useFormikStepper must be used within FormikProviderWrapper');
    }
    return context;
};